import React from "react";
import { Button } from "../Button/Button";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import "./PrivacyPolicyModal.scss";

/**
 * Modal que muestra las políticas de privacidad de la aplicación.
 * Utiliza Material-UI Dialog para renderizar el contenido en una ventana modal.
 * @param {boolean} openPrivacyPolicy - Estado que controla si el modal está abierto
 * @param {Function} handleClosePrivacyPolicy - Función para cerrar el modal
 * @param {JSX.Element} props.politicas - Contenido HTML que se mostrará dentro del modal.

 * @returns {JSX.Element} Componente PrivacyPolicyModal renderizado
 */
export const PrivacyPolicyModal = ({
  openPrivacyPolicy,
  handleClosePrivacyPolicy,
  politicas,
}) => {
  return (
    <Dialog
      maxWidth="sm"
      open={openPrivacyPolicy}
      onClose={handleClosePrivacyPolicy}
      className="privacy-policy-dialog"
    >
      <DialogTitle className="privacy-policy-dialog__title">
        Políticas de privacidad
      </DialogTitle>
      <DialogContent>
        <div
          className="privacy-policy-dialog__description"
          dangerouslySetInnerHTML={{ __html: politicas }}
        />
      </DialogContent>
      <DialogActions>
        <div className="privacy-policy-dialog__actions">
          <Button onClick={handleClosePrivacyPolicy} autoFocus size="medium">
            Aceptar
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
